<template>
  <form @submit.prevent="createOrUpdateUpgrade()">
    <h6 class="heading-small text-muted mb-4">ข้อมูลร้าน</h6>
    <div class="row">
      <div class="col-lg-6">
        <div class="form-group">
          <label>
            <span class="text-danger">*</span> ชื่อร้าน/ชื่อสาขา
            <span class="text-red">(ภาษาไทย)</span>
          </label>
          <input
            type="text"
            class="form-control"
            placeholder="ชื่อร้าน/ชื่อสาขา (ภาษาไทย)"
            :class="{
              'is-invalid': submittEdit && $v.brance.branceName.$error,
            }"
            v-model="brance.branceName" />
          <!-- vuelidate -->
          <label
            class="error invalid-feedback"
            v-if="!$v.brance.branceName.minLength"
            >กรุณากรอก"ชื่อร้าน/ชื่อสาขา"อย่างน้อย
            {{ $v.brance.branceName.$params.minLength.min }} ตัวอักษร</label
          >
          <label
            v-if="submittEdit && !$v.brance.branceName.required"
            class="invalid-feedback"
            >กรุณากรอกชื่อร้าน/ชื่อสาขา</label
          >
        </div>
      </div>
      <div class="col-lg-6">
        <div class="form-group">
          <label> ชื่อบริษัท (ถ้ามี กรณีเป็นนิติบุคคล) </label>
          <input
            type="text"
            class="form-control"
            placeholder="ชื่อบริษัท (ถ้ามี กรณีเป็นนิติบุคคล)"
            v-model="brance.companyName" />
        </div>
      </div>
      <div class="col-lg-6">
        <div class="form-group">
          <label>
            <span class="text-danger">*</span> เบอร์โทรศัพท์ร้านค้า
          </label>
          <input
            type="number"
            class="form-control hide-arrow"
            :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 190'"
            placeholder="เบอร์โทรศัพท์ร้านค้า"
            :class="{ 'is-invalid': submittEdit && $v.brance.branceTel.$error }"
            v-model="brance.branceTel" />
          <!-- vuelidate -->
          <label
            v-if="submittEdit && !$v.brance.branceTel.required"
            class="invalid-feedback"
            >กรุณากรอกเบอร์โทรศัพท์ร้านค้า</label
          >
          <label
            class="error invalid-feedback"
            v-if="!$v.brance.branceTel.minLength"
            >กรุณากรอก"เบอร์โทรศัพท์ร้านค้า"อย่างน้อย
            {{ $v.brance.branceTel.$params.minLength.min }}ตัวเลข</label
          >
        </div>
      </div>
      <div
        class="col-lg-6"
        v-if="
          $USER_LOGIN.get().isAdmin && this.$THEME.manageVision.brancePackage
        ">
        <div class="form-group">
          <label> แพ็กเกจ </label>
          <input
            disabled
            type="text"
            class="form-control"
            placeholder="แพ็กเกจ"
            v-model="brance.package" />
        </div>
      </div>
      <div class="col-lg-6" v-if="$USER_LOGIN.get().isAdmin">
        <div class="form-group">
          <label> วันเซ็นสัญญา </label>
          <input
            disabled
            type="date"
            class="form-control"
            placeholder="วันเซ็นสัญญา"
            v-model="brance.contractDate" />
        </div>
      </div>
    </div>
    <hr class="my-4" />
    <template v-if="$USER_LOGIN.get().isAdmin">
      <hr class="my-4" />
      <div class="mt-4 w-100 text-right">
        <b-button variant="secondary" @click="resetForm()">กรอกใหม่</b-button>
        <b-button type="submit" variant="info">บันทึก</b-button>
      </div>
    </template>
  </form>
</template>

<script>
import AutocompletesAddress from "@/components/Autocomplete/AddressTH/AutocompleteAddressTH";
import {
  required,
  minLength,
  maxLength,
  numeric,
  requiredIf,
} from "vuelidate/lib/validators";
import validatePop from "@/plugins/validatePop.js";
import swapLang from "../../../plugins/swapLang.js";
import {
  showSuccessModal,
  showErrorModal,
} from "@/components/modalNotification.js";
import { serviceAreaBrance } from "@/plugins/formatForBrance.js";
import configPOPTheme from "@/config/POPTheme";
export default {
  name: "BranceUpgrade",
  components: {
    AutocompletesAddress,
  },
  props: {
    submittEdit: Boolean,
    brance: Object,
  },
  validations() {
    return this.rule;
  },
  data() {
    return {
      customTheme: configPOPTheme,
      serviceAreaBrance: serviceAreaBrance,
      natureBusiness: [
        "ร้านขายของชำ",
        "ร้านกาแฟ",
        "ร้านอาหาร",
        "ร้านขายยา",
        "อื่นๆ",
      ],
      packageShop: [
        { value: "POP", text: "POP" },
        { value: "POPPLUS", text: "POP+" },
        { value: "POPSHOP", text: "POP-SHOP" },
      ],
      conditionArea: [
        { value: "0.5", text: "500 เมตร" },
        { value: "1.00", text: "1 กิโลเมตร" },
        { value: "2.00", text: "2 กิโลเมตร" },
        { value: "3.00", text: "3 กิโลเมตร" },
        { value: "4.00", text: "4 กิโลเมตร" },
        { value: "5.00", text: "5 กิโลเมตร" },
      ],
      typeCod: [
        { value: "1", text: "ใช้งาน" },
        { value: "0", text: "ไม่ใช้งาน" },
      ],
      detailPackage: configPOPTheme.customShopPackage || [
        { value: "TRIAL", text: "ทดลองใช้ 7 วัน" },
        { value: "1", text: "1 เดือน" },
        { value: "3", text: "3 เดือน" },
        { value: "6", text: "6 เดือน" },
        { value: "12", text: "12 เดือน" },
      ],
      center: {
        lat: 13.7303559,
        lng: 100.5363907,
      },
      icon: {
        url: require("../../../assets/images/home.svg"),
        size: { width: 50, height: 50, f: "px", b: "px" },
        scaledSize: { width: 50, height: 50, f: "px", b: "px" },
      },
      contentAddress: "",
      open: {
        monday: "",
        tuesday: "",
        wednesday: "",
        thursday: "",
        friday: "",
        saturday: "",
        sunday: "",
        holidays: "",
      },
      close: {
        monday: "",
        tuesday: "",
        wednesday: "",
        thursday: "",
        friday: "",
        saturday: "",
        sunday: "",
        holidays: "",
      },
    };
  },
  methods: {
    createOrUpdateUpgrade() {
      this.$emit("update:submittEdit", true);
      this.$v.brance.$touch();
      if (this.$v.brance.$invalid) {
        return false;
      }
      if (this.brance.natureBusiness == "อื่นๆ") {
        this.brance.natureBusiness = this.brance.natureBusinessOther;
      }
      this.$emit("handleLoader");
      this.$http
        .post(
          this.$API_URL + "/shop/shop/detail",
          {
            type: "brance",
            name: this.brance.branceName,
            name_eng: this.brance.branceNameEng,
            tel: this.brance.branceTel,
            company_name: this.brance.companyName,
            nature_business: this.brance.natureBusiness,
            address: this.brance.address,
            state: this.brance.state,
            district: this.brance.district,
            province: this.brance.province,
            postcode: this.brance.postcode,
            address_eng: this.brance.addressEng,
            state_eng: this.brance.stateEng,
            district_eng: this.brance.districtEng,
            province_eng: this.brance.provinceEng,
            postcode_eng: this.brance.postcodeEng,
            latitude_shop: this.brance.latitudeShop,
            longitude_shop: this.brance.longitudeShop,
            location_near: this.brance.locationNear,
            closed_day: this.brance.closedDay,
          },
          {
            headers: {
              Token: localStorage.getItem("access_token"),
            },
          }
        )
        .then((res) => {
          let checkError = validatePop(res);
          this.$emit("handleLoader");
          if (!checkError.status) {
            showErrorModal(checkError.msg);
            return false;
          }
          showSuccessModal("บันทึกข้อมูลร้านสำเร็จ");
        })
        .catch((error) => {});
    },
    onSubmitAddress(ads, objKey) {
      Object.keys(this[objKey]).forEach((key) => {
        if (ads[key]) {
          this[objKey][key] = ads[key];
        } else if (key == "state") {
          this[objKey]["state"] = ads["sub-district"];
        } else {
          this[objKey][key] = this[objKey][key];
        }
      });
    },
    swapText(text) {
      let swap = text.split("");
      let swapText = "";
      swap.forEach((value) => {
        if (swapLang[value] && !["/", "-", ".", ","].includes(value)) {
          swapText += swapLang[value];
        } else {
          swapText += value;
        }
      });
      return swapText;
    },
    clearInputClosedDay(key, index) {
      this.optionsClosedDay[index].item[key] = { open: "", close: "" };
      this.$refs[key + "open"][0].value = "";
      this.$refs[key + "close"][0].value = "";
    },
    clearInputLocationNear(key, index) {
      this.optionsLocationNear[index].item[key] = "";
      this.$refs[key][0].value = "";
    },
    mapInputLocationNear(key, index, value) {
      let i = this.brance.locationNear.findIndex((location) => {
        return Object.keys(location) == key;
      });
      if (i > -1) {
        this.brance.locationNear[i][key] = value;
      }
      this.optionsLocationNear[index].item[key] = value;
    },
    mapLocationNear(key) {
      let index = this.optionsLocationNear.findIndex((location) => {
        return location.key == key;
      });
      if (this.optionsLocationNear[index].item[key] == "") {
        return true;
      }
      return false;
    },
    mapInputClosedDayOpen(key, index, value) {
      let i = this.brance.closedDay.findIndex((day) => {
        return Object.keys(day) == key;
      });
      if (i > -1) {
        this.brance.closedDay[i][key].open = value;
      }
      this.optionsClosedDay[index].item[key].open = value;
    },
    mapInputClosedDayClose(key, index, value) {
      let i = this.brance.closedDay.findIndex((day) => {
        return Object.keys(day) == key;
      });
      if (i > -1) {
        this.brance.closedDay[i][key].close = value;
      }
      this.optionsClosedDay[index].item[key].close = value;
    },
    mapClosedDay(type, key) {
      let index = this.optionsClosedDay.findIndex((day) => {
        return day.key == key;
      });
      if (type == "open" && this.optionsClosedDay[index].item[key].open == "") {
        return true;
      }
      if (
        type == "close" &&
        this.optionsClosedDay[index].item[key].close == ""
      ) {
        return true;
      }
      return false;
    },
    disableLocation(key) {
      return !this.brance.locationNear.some((item) => Object.keys(item) == key);
    },
    disableClosedDay(key) {
      return !this.brance.closedDay.some((item) => Object.keys(item) == key);
    },
    updateLocation(location) {
      this.brance.latitudeShop = location.latLng.lat();
      this.brance.longitudeShop = location.latLng.lng();
      this.searchLocation("", {
        lat: this.brance.latitudeShop,
        lng: this.brance.longitudeShop,
      });
    },
    autoSearchLocationShop() {
      let res = false;
      let data = {};
      let address = "";

      Object.keys(this.brance).forEach((key) => {
        if (
          ["address", "state", "district", "province", "postcode"].includes(key)
        ) {
          data[key] = this.brance[key];
        }
      });
      res = Object.values(data).every((val) => val != "" || val.length > 0);
      if (res) {
        address = [
          this.brance.address,
          this.brance.state,
          this.brance.district,
          this.brance.province,
          this.brance.postcode,
        ].join(" ");
        this.searchLocation(address, {
          lat: 0,
          lng: 0,
        });
      }
    },
    searchLocation(address, latLng) {
      let geocoder = new google.maps.Geocoder();
      geocoder.geocode(
        { address: address, location: latLng },
        (results, status) => {
          if (status === "OK") {
            if (latLng.lat && latLng.lng > 0) {
              this.contentAddress = results[0].formatted_address;
            }
            if (address) {
              this.brance.latitudeShop = results[0].geometry.location.lat();
              this.brance.longitudeShop = results[0].geometry.location.lng();
              this.contentAddress = address;
              this.center.lat = this.brance.latitudeShop;
              this.center.lng = this.brance.longitudeShop;
            }
          }
        }
      );
    },
    copyLink() {
      let Url = this.$refs.linkMap;
      Url.innerHTML = window.location.href;
      Url.select();
      document.execCommand("copy");
    },
    resetForm() {
      Object.keys(this.brance).forEach((key) => {
        if (
          ![
            "apiKey",
            "contractDate",
            "package",
            "serviceAreaCondition",
            "selectedCod",
            "selectTrial",
            "member",
            "dateExp",
          ].includes(key)
        ) {
          if (key == "closedDay") {
            this.brance[key].forEach((item, index) => {
              this.clearInputClosedDay(Object.keys(item), index);
            });
            this.brance[key] = [];
          } else if (key == "locationNear") {
            this.brance[key].forEach((item, index) => {
              this.clearInputLocationNear(Object.keys(item), index);
            });
            this.brance[key] = [];
          } else if (["latitudeShop", "longitudeShop"].includes(key)) {
            this.brance[key] = 0;
          } else {
            this.brance[key] = "";
          }
        }
      });
    },
  },
  computed: {
    optionsLocationNear() {
      return [
        { item: { dorm: "" }, name: "หอพัก", key: "dorm" },
        { item: { village: "" }, name: "หมู่บ้าน", key: "village" },
        { item: { market: "" }, name: "ตลาด", key: "market" },
        { item: { condo: "" }, name: "คอนโด", key: "condo" },
        { item: { building: "" }, name: "อาคารพาณิชย์", key: "building" },
        { item: { road: "" }, name: "ติดถนนใหญ่", key: "road" },
        { item: { gas: "" }, name: "ปั๊มน้ำมัน", key: "gas" },
        { item: { mall: "" }, name: "ในห้างสรรพสินค้า", key: "mall" },
        { item: { other: "" }, name: "อื่นๆ โปรดระบุ", key: "other" },
      ];
    },
    optionsClosedDay() {
      return [
        {
          item: { monday: { open: "", close: "" } },
          name: "จันทร์",
          key: "monday",
        },
        {
          item: { tuesday: { open: "", close: "" } },
          name: "อังคาร",
          key: "tuesday",
        },
        {
          item: { wednesday: { open: "", close: "" } },
          name: "พุธ",
          key: "wednesday",
        },
        {
          item: { thursday: { open: "", close: "" } },
          name: "พฤหัสบดี",
          key: "thursday",
        },
        {
          item: { friday: { open: "", close: "" } },
          name: "ศุกร์",
          key: "friday",
        },
        {
          item: { saturday: { open: "", close: "" } },
          name: "เสาร์",
          key: "saturday",
        },
        {
          item: { sunday: { open: "", close: "" } },
          name: "อาทิตย์",
          key: "sunday",
        },
        {
          item: { holidays: { open: "", close: "" } },
          name: "วันหยุดนักขัตฤกษ์",
          key: "holidays",
        },
      ];
    },
    rule() {
      let res = {
        brance: {
          branceName: { required, minLength: minLength(2) },
          branceNameEng: { required },
          branceTel: { required, minLength: minLength(9) },
          natureBusiness: { required },
          natureBusinessOther: {
            required: requiredIf(function (business) {
              return business.natureBusiness == "อื่นๆ";
            }),
          },
          address: { required, minLength: minLength(5) },
          state: { required },
          district: { required },
          province: { required },
          postcode: {
            required,
            numeric,
            minLength: minLength(4),
            maxLength: maxLength(5),
          },
          addressEng: { required },
          stateEng: { required },
          districtEng: { required },
          provinceEng: { required },
          postcodeEng: {
            required,
            numeric,
            minLength: minLength(4),
            maxLength: maxLength(5),
          },
          locationNear: { required },
          latitudeShop: { required },
          longitudeShop: { required },
          closedDay: { required, minLength: minLength(4) },
        },
      };
      this.optionsLocationNear.forEach((location) => {
        res.brance[location.key] = {
          required: requiredIf(function () {
            return (
              !this.disableLocation(location.key) &&
              this.mapLocationNear(location.key)
            );
          }),
        };
      });
      this.optionsClosedDay.forEach((day) => {
        res.brance[day.key + "Open"] = {
          required: requiredIf(function () {
            return (
              !this.disableClosedDay(day.key) &&
              this.mapClosedDay("open", day.key)
            );
          }),
        };
        res.brance[day.key + "Close"] = {
          required: requiredIf(function () {
            return (
              !this.disableClosedDay(day.key) &&
              this.mapClosedDay("close", day.key)
            );
          }),
        };
      });

      return res;
    },
  },
};
</script>

<style>
.is-invalid {
  border-color: red !important;
}
</style>
